module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('bar-chart', {
    attrs: {
      "data": _vm.data,
      "domain": _vm.domain,
      "margin": _vm.margin,
      "barColor": _vm.barColor,
      "tip-label": _vm.tipLabel
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col col-6"
  }, [_c('h3', [_vm._v("Purple Cap Awards")]), _vm._v(" "), _c('p', [_vm._v("\n      This chart visualizes all the Purple cap winners in IPL from (2008-2016)\n      in left-to-right direction.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      Purple Cap is awarded to the Bowler with most wickets at the end of every\n      IPL season.\n    ")]), _vm._v(" "), _c('small', [_vm._v("* Hover over the bars to see the actual values")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col col-6"
  }, [_c('h3', [_vm._v("Trivia")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n        Dwayne Bravo has won the purple cap twice, in 2013 & 2015.\n      ")]), _vm._v(" "), _c('li', [_vm._v("\n        Dwayne Bravo took the most wickets(32) in 2011, most for any purple\n        cap winner.\n      ")]), _vm._v(" "), _c('li', [_vm._v("\n        RP singh in 2009, Mohit Sharma in 2014 and Bhuvneshwar Kumar in 2016,\n        won the purple cap with exact same wicket haul(23).\n      ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37b70e4c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/AwardsPurpleCaps.vue
// module id = 397
// module chunks = 1